import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { validateTokenEmailId } from "../utils/services";

const PrivateRoutes = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setIsLoading] = useState(true);

  useEffect(() => {
    if (
      !!window.sessionStorage.getItem("token") &&
      !!window.sessionStorage.getItem("user_id")
    ) {
      let requestBody = {
        token: window.sessionStorage.getItem("token"),
        email: window.sessionStorage.getItem("user_id"),
      };

      validateTokenEmailId(requestBody).then((response) => {
        if (response.data.status) {
          console.log("------ resp ----> ", response);
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
        }
        setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  return !loading && (isLoggedIn ? <Outlet /> : <Navigate to="/login" />);
};

export default PrivateRoutes;
